<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ArenaEquipmentVersionForm v-if="equipmentVersion" :equipmentVersion="equipmentVersion" />
      <LoadingPage v-if="!equipmentVersion"/>
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaEquipmentVersionForm from '@/components/settings/arena/equipment-version/ArenaEquipmentVersionForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'ArenaEquipmentEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaEquipmentVersionForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      equipmentVersion: state => state.arena.equipmentVersionById
    })
  },
  methods: {
    ...mapActions('arena', ['fetchArenaEquipmentVersionById'])
  },
  mounted () {
    this.fetchArenaEquipmentVersionById(this.$route.params.id)
  }
}
</script>
